import { useEffect, useState } from "react";
import { BigHeading, DatePickerContainer, FlexContainer, FormContainer, GreenButton, Label, SearchingBoxContainer, SearchingListContainer } from "../assets/style";
import MainContent from "./MainContent";
import ReactLoading from "react-loading";
import { Stack } from "@mui/system";
import { Autocomplete, TextField } from "@mui/material";
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React from "react";
import ResultDataGrid from "../components/DataGrids/ResultDataGrid";
import { useLazyGetResultLogQuery } from "../features/resultLog/resultLogSlice";

const Result = () => {
    const [castForm, setCastForm] = React.useState<Dayjs | string | null>(dayjs(new Date()).subtract(7, 'day')); // default 1 week 
    const [castTo, setCastTo] = React.useState<Dayjs | null>(dayjs(new Date()));
    const [testForm, setTestForm] = React.useState<Dayjs | string | null>(dayjs(new Date()).subtract(7, 'day')); // default 1 week 
    const [testTo, setTestTo] = React.useState<Dayjs | null>(dayjs(new Date()));
    const [code, setCode] = useState('')
    const [name, setName] = useState('')
    const [getResultLogQuery, { data: testResultData, isLoading, isSuccess, isError, error, isFetching }] = useLazyGetResultLogQuery()
    const [testResult, setTestResult] = React.useState<testResultType[]>([])
    const [counter, setCounter] = useState(0)
    type testResultType = {
        "id" : Number
        "customerName": String,
        "rfid": String,
        "width": String,
        "length": String,
        "height": String,
        "squareness": String,
        "massInAir": String,
        "massInWater": String,
        "densityByCalculation": String | null,
        "densityByWaterDisplacement": String | null,
        "loadAtFailure": String,
        "typeOfFacture": String
    }
    
    useEffect(() => {
        getResultLogQuery({
            'CustomerName' : name,
            'Rfid' : code,
            'DateCastFrom' : (castForm as Dayjs)?.toISOString(),
            'DateCastTo': (castTo as Dayjs)?.toISOString(),
            'DateTestFrom': (testForm as Dayjs)?.toISOString(),
            'DateTestTo': (testTo as Dayjs)?.toISOString()
        })
    }, [counter])

    useEffect(() => {
        if (isSuccess) {
            const rows: testResultType[] = (testResultData as any[])?.map((item: any, index: number) => {
                return {
                    id: index,
                    ...item
                }
            }) ?? []
            setTestResult(rows)
        }
    }, [testResultData])

    useEffect(() => {
        if (isError) {
            setTestResult([])
            alert((error as any).error)
        }
    }, [error])

    function search() {
        setCounter(counter + 1)
    }
    return (
        <>
            <MainContent type={"result"} >
                <BigHeading >Result</BigHeading>
                <SearchingBoxContainer >
                    <br></br>
                    <div >
                        <FlexContainer>
                            <Label>Date Cast:</Label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <FlexContainer>
                                    <DatePickerContainer>
                                        <DatePicker
                                            label="Cast Form"
                                            value={castForm}
                                            sx={{ marginLeft: '20px' }}
                                            onChange={(newValue) => setCastForm(newValue)}
                                        />
                                    </DatePickerContainer>

                                    <DatePickerContainer>
                                        <DatePicker
                                            label="Cast To"
                                            value={castTo}
                                            sx={{ marginLeft: '20px' }}
                                            onChange={(newValue) => setCastTo(newValue)}
                                        />
                                    </DatePickerContainer>
                                </FlexContainer>

                            </LocalizationProvider>


                            <Label>RFID/QR Code:</Label>
                            <TextField
                                id="code"
                                label="RFID/QR Code"
                                variant="outlined"
                                value={code}
                                onChange={(e) => { setCode(e.target.value) }}
                                style={{ marginLeft: '20px' }}
                            />
                        </FlexContainer>
                    </div>

                    <br></br>
                    <div >
                        <FlexContainer>
                            <Label >Date Test:</Label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <FlexContainer>
                                    <DatePickerContainer>
                                        <DatePicker
                                            label="Test Form"
                                            value={testForm}
                                            sx={{ marginLeft: '20px' }}
                                            onChange={(newValue) => setTestForm(newValue)}
                                        />
                                    </DatePickerContainer>

                                    <DatePickerContainer>
                                        <DatePicker
                                            label="Test To"
                                            value={testTo}
                                            sx={{ marginLeft: '20px' }}
                                            onChange={(newValue) => setTestTo(newValue)}
                                        />
                                    </DatePickerContainer>
                                </FlexContainer>

                            </LocalizationProvider>
                            <Label>Customer Name:</Label>
                            <TextField
                                id="name"
                                label="Customer Name"
                                variant="outlined"
                                value={name}
                                onChange={(e) => { setName(e.target.value) }}
                                style={{ marginLeft: '20px' }}
                            />
                            <FlexContainer>
                                <GreenButton
                                    onClick={search}
                                    style={{ marginLeft: '20px', height: '30px' }}
                                    variant="contained"
                                    type="submit"
                                >
                                    Search
                                </GreenButton>
                            </FlexContainer>
                        </FlexContainer>


                    </div >

                    <br></br>
                </SearchingBoxContainer>

                <SearchingListContainer>
                    {
                        isFetching && <ReactLoading className="justify-items-center" type={"bubbles"} color={'#9e9e9e'} height={'20%'} width={'20%'} />
                    }
                    {
                        !isFetching && <ResultDataGrid testResult={testResult} />
                    }                    
                </SearchingListContainer>
            </MainContent >
        </>
    )
};
export default Result;